import { Button } from '@mui/material'
import React, { useState, useContext } from 'react';
import TrainingFormModal from './TrainingFormModal'


const TrainNewModelButton = ({ onTrainingCreated, disabled = false }) => {
  const [open, setOpen] = useState(false);

  const handleTrainingCreated = (trainingId) => {
    if (onTrainingCreated) {
      onTrainingCreated(trainingId);
    }
    setOpen(false);
  };

  return (
    <>
      <Button
          variant="contained"
          sx={{
            borderRadius: '12px',
            backgroundColor: '#16a4b0',
            color: 'white',
            textTransform: 'none',
            fontSize: '18px', 
            ml: 2,
            width: '20%',
            '&:hover': { backgroundColor: '#00707c' },
          }}
          disabled={disabled}
          onClick={() => setOpen(true)}
          >
          Train New Model
      </Button>
      <TrainingFormModal 
        open={open} 
        onClose={() => setOpen(false)}
        onTrainingCreated={handleTrainingCreated} 
      />
    </>
  )
}

export default TrainNewModelButton